import { create } from 'zustand'

export const useThemeStore = create((set) => ({
  theme: localStorage.getItem('scribenza_theme') || 'dark',
  setTheme: (theme) => {
    localStorage.setItem('scribenza_theme', theme)
    set({ theme })
  },
  toggle: () => set((state) => {
    const next = state.theme === 'dark' ? 'light' : 'dark'
    localStorage.setItem('scribenza_theme', next)
    return { theme: next }
  }),
}))
